// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
  }
  a {
    color: #fff;
    text-decoration: none;
  }
  .pg-footer {
    font-family: 'Roboto', sans-serif;
    bottom: 0;
    width: 100vw;
    position: relative;
    margin-top: 90vh;
  }

  .footer {
      background-color: #004658;
      color: #fff;
  }
  .footer-wave-svg {
      background-color: transparent;
      display: block;
      height: 30px;
      position: relative;
      top: -1px;
      width: 100%;
  }
  .footer-wave-path {
      fill: #dcdcdc;
  }
  
  .footer-content {
      margin-left: auto;
      margin-right: auto;
      max-width: 1230px;
      padding: 40px 15px 450px;
      position: relative;
  }
  
  .footer-content-column {
      box-sizing: border-box;
      float: left;
      padding-left: 15px;
      padding-right: 15px;
      width: 100%;
      color: #fff;
  }
  
  .footer-content-column ul li a {
    color: #fff;
    text-decoration: none;
  }
  
  .footer-logo-link {
      display: inline-block;
  }
  .footer-menu {
      margin-top: 30px;
  }
  
  .footer-menu-name {
      color: #fffff2;
      font-size: 15px;
      font-weight: 900;
      letter-spacing: .1em;
      line-height: 18px;
      margin-bottom: 0;
      margin-top: 0;
      text-transform: uppercase;
  }
  .footer-menu-list {
      list-style: none;
      margin-bottom: 0;
      margin-top: 10px;
      padding-left: 0;
  }
  .footer-menu-list li {
      margin-top: 5px;
  }
  
  .footer-call-to-action-description {
      color: #fffff2;
      margin-top: 10px;
      margin-bottom: 20px;
  }
  .footer-call-to-action-button:hover {
      background-color: #fffff2;
      color: #00bef0;
  }
  .button:last-of-type {
      margin-right: 0;
  }
  .footer-call-to-action-button {
      background-color: #027b9a;
      border-radius: 21px;
      color: #fffff2;
      display: inline-block;
      font-size: 11px;
      font-weight: 900;
      letter-spacing: .1em;
      line-height: 18px;
      padding: 12px 30px;
      margin: 0 10px 10px 0;
      text-decoration: none;
      text-transform: uppercase;
      transition: background-color .2s;
      cursor: pointer;
      position: relative;
  }
  .footer-call-to-action {
      margin-top: 30px;
  }
  .footer-call-to-action-title {
      color: #fffff2;
      font-size: 14px;
      font-weight: 900;
      letter-spacing: .1em;
      line-height: 18px;
      margin-bottom: 0;
      margin-top: 0;
      text-transform: uppercase;
  }
  .footer-call-to-action-link-wrapper {
      margin-bottom: 0;
      margin-top: 10px;
      color: #fff;
      text-decoration: none;
  }
  .footer-call-to-action-link-wrapper a {
      color: #fff;
      text-decoration: none;
  }
  
  
  
  
  
  .footer-social-links {
      bottom: 0;
      height: 54px;
      position: absolute;
      right: 0;
      width: 236px;
  }
  
  .footer-social-amoeba-svg {
      height: 54px;
      left: 0;
      display: block;
      position: absolute;
      top: 0;
      width: 236px;
  }
  
  .footer-social-amoeba-path {
      fill: #027b9a;
  }
  
  .footer-social-link.linkedin {
      height: 26px;
      left: 3px;
      top: 11px;
      width: 26px;
  }
  
  .footer-social-link {
      display: block;
      padding: 10px;
      position: absolute;
  }
  
  .hidden-link-text {
      position: absolute;
      clip: rect(1px 1px 1px 1px);
      clip: rect(1px,1px,1px,1px);
      clip-path: inset(0px 0px 99.9% 99.9%);
      overflow: hidden;
      height: 1px;
      width: 1px;
      padding: 0;
      border: 0;
      top: 50%;
  }
  
  .footer-social-icon-svg {
      display: block;
  }
  
  .footer-social-icon-path {
      fill: #fffff2;
      transition: fill .2s;
  }
  
  .footer-social-link.twitter {
      height: 28px;
      left: 62px;
      top: 3px;
      width: 28px;
  }
  
  .footer-social-link.youtube {
      height: 24px;
      left: 123px;
      top: 12px;
      width: 24px;
  }
  
  .footer-social-link.github {
      height: 34px;
      left: 172px;
      top: 7px;
      width: 34px;
  }
  
  .footer-copyright {
      background-color: #027b9a;
      color: #fff;
      padding: 15px 30px;
    text-align: center;
  }
  
  .footer-copyright-wrapper {
      margin-left: auto;
      margin-right: auto;
      max-width: 1200px;
  }
  
  .footer-copyright-text {
    color: #fff;
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
      margin-bottom: 0;
      margin-top: 0;
  }
  
  .footer-copyright-link {
      color: #fff;
      text-decoration: none;
  }
  
  
  
  
  
  
  
  /* Media Query For different screens */
  @media (min-width:320px) and (max-width:479px)  { /* smartphones, portrait iPhone, portrait 480x320 phones (Android) */
    .footer-content {
      margin-left: auto;
      margin-right: auto;
      max-width: 1230px;
      padding: 40px 15px 450px;
      position: relative;
    }
  }
  @media (min-width:480px) and (max-width:599px)  { /* smartphones, Android phones, landscape iPhone */
    .footer-content {
      margin-left: auto;
      margin-right: auto;
      max-width: 1230px;
      padding: 40px 15px 450px;
      position: relative;
    }
  }
  @media (min-width:600px) and (max-width: 800px)  { /* portrait tablets, portrait iPad, e-readers (Nook/Kindle), landscape 800x480 phones (Android) */
    .footer-content {
      margin-left: auto;
      margin-right: auto;
      max-width: 1230px;
      padding: 40px 15px 450px;
      position: relative;
    }
  }
  @media (min-width:801px)  { /* tablet, landscape iPad, lo-res laptops ands desktops */
  
  }
  @media (min-width:1025px) { /* big landscape tablets, laptops, and desktops */
  
  }
  @media (min-width:1281px) { /* hi-res laptops and desktops */
  
  }
  
  
  
  
  @media (min-width: 760px) {
    .footer-content {
        margin-left: auto;
        margin-right: auto;
        max-width: 1230px;
        padding: 40px 15px 450px;
        position: relative;
    }
  
    .footer-wave-svg {
        height: 50px;
    }
  
    .footer-content-column {
        width: 24.99%;
    }
  }
  @media (min-width: 568px) {
    /* .footer-content-column {
        width: 49.99%;
    } */
  }`, "",{"version":3,"sources":["webpack://./src/components/footer.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;EACZ;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,iCAAiC;IACjC,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;MACI,yBAAyB;MACzB,WAAW;EACf;EACA;MACI,6BAA6B;MAC7B,cAAc;MACd,YAAY;MACZ,kBAAkB;MAClB,SAAS;MACT,WAAW;EACf;EACA;MACI,aAAa;EACjB;;EAEA;MACI,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;MACjB,wBAAwB;MACxB,kBAAkB;EACtB;;EAEA;MACI,sBAAsB;MACtB,WAAW;MACX,kBAAkB;MAClB,mBAAmB;MACnB,WAAW;MACX,WAAW;EACf;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;MACI,qBAAqB;EACzB;EACA;MACI,gBAAgB;EACpB;;EAEA;MACI,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,iBAAiB;MACjB,gBAAgB;MAChB,aAAa;MACb,yBAAyB;EAC7B;EACA;MACI,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB;MAChB,eAAe;EACnB;EACA;MACI,eAAe;EACnB;;EAEA;MACI,cAAc;MACd,gBAAgB;MAChB,mBAAmB;EACvB;EACA;MACI,yBAAyB;MACzB,cAAc;EAClB;EACA;MACI,eAAe;EACnB;EACA;MACI,yBAAyB;MACzB,mBAAmB;MACnB,cAAc;MACd,qBAAqB;MACrB,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,iBAAiB;MACjB,kBAAkB;MAClB,qBAAqB;MACrB,qBAAqB;MACrB,yBAAyB;MACzB,gCAAgC;MAChC,eAAe;MACf,kBAAkB;EACtB;EACA;MACI,gBAAgB;EACpB;EACA;MACI,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,iBAAiB;MACjB,gBAAgB;MAChB,aAAa;MACb,yBAAyB;EAC7B;EACA;MACI,gBAAgB;MAChB,gBAAgB;MAChB,WAAW;MACX,qBAAqB;EACzB;EACA;MACI,WAAW;MACX,qBAAqB;EACzB;;;;;;EAMA;MACI,SAAS;MACT,YAAY;MACZ,kBAAkB;MAClB,QAAQ;MACR,YAAY;EAChB;;EAEA;MACI,YAAY;MACZ,OAAO;MACP,cAAc;MACd,kBAAkB;MAClB,MAAM;MACN,YAAY;EAChB;;EAEA;MACI,aAAa;EACjB;;EAEA;MACI,YAAY;MACZ,SAAS;MACT,SAAS;MACT,WAAW;EACf;;EAEA;MACI,cAAc;MACd,aAAa;MACb,kBAAkB;EACtB;;EAEA;MACI,kBAAkB;MAClB,2BAA2B;MAC3B,2BAA2B;MAE3B,qCAAqC;MACrC,gBAAgB;MAChB,WAAW;MACX,UAAU;MACV,UAAU;MACV,SAAS;MACT,QAAQ;EACZ;;EAEA;MACI,cAAc;EAClB;;EAEA;MACI,aAAa;MACb,oBAAoB;EACxB;;EAEA;MACI,YAAY;MACZ,UAAU;MACV,QAAQ;MACR,WAAW;EACf;;EAEA;MACI,YAAY;MACZ,WAAW;MACX,SAAS;MACT,WAAW;EACf;;EAEA;MACI,YAAY;MACZ,WAAW;MACX,QAAQ;MACR,WAAW;EACf;;EAEA;MACI,yBAAyB;MACzB,WAAW;MACX,kBAAkB;IACpB,kBAAkB;EACpB;;EAEA;MACI,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;EACrB;;EAEA;IACE,WAAW;MACT,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,aAAa;EACjB;;EAEA;MACI,WAAW;MACX,qBAAqB;EACzB;;;;;;;;EAQA,sCAAsC;EACtC,kDAAkD,oEAAoE;IACpH;MACE,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;MACjB,wBAAwB;MACxB,kBAAkB;IACpB;EACF;EACA,kDAAkD,kDAAkD;IAClG;MACE,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;MACjB,wBAAwB;MACxB,kBAAkB;IACpB;EACF;EACA,mDAAmD,iGAAiG;IAClJ;MACE,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;MACjB,wBAAwB;MACxB,kBAAkB;IACpB;EACF;EACA,4BAA4B,yDAAyD;;EAErF;EACA,4BAA4B,iDAAiD;;EAE7E;EACA,4BAA4B,gCAAgC;;EAE5D;;;;;EAKA;IACE;QACI,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;QACjB,wBAAwB;QACxB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;EACF;EACA;IACE;;OAEG;EACL","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n  }\n  a {\n    color: #fff;\n    text-decoration: none;\n  }\n  .pg-footer {\n    font-family: 'Roboto', sans-serif;\n    bottom: 0;\n    width: 100vw;\n    position: relative;\n    margin-top: 90vh;\n  }\n\n  .footer {\n      background-color: #004658;\n      color: #fff;\n  }\n  .footer-wave-svg {\n      background-color: transparent;\n      display: block;\n      height: 30px;\n      position: relative;\n      top: -1px;\n      width: 100%;\n  }\n  .footer-wave-path {\n      fill: #dcdcdc;\n  }\n  \n  .footer-content {\n      margin-left: auto;\n      margin-right: auto;\n      max-width: 1230px;\n      padding: 40px 15px 450px;\n      position: relative;\n  }\n  \n  .footer-content-column {\n      box-sizing: border-box;\n      float: left;\n      padding-left: 15px;\n      padding-right: 15px;\n      width: 100%;\n      color: #fff;\n  }\n  \n  .footer-content-column ul li a {\n    color: #fff;\n    text-decoration: none;\n  }\n  \n  .footer-logo-link {\n      display: inline-block;\n  }\n  .footer-menu {\n      margin-top: 30px;\n  }\n  \n  .footer-menu-name {\n      color: #fffff2;\n      font-size: 15px;\n      font-weight: 900;\n      letter-spacing: .1em;\n      line-height: 18px;\n      margin-bottom: 0;\n      margin-top: 0;\n      text-transform: uppercase;\n  }\n  .footer-menu-list {\n      list-style: none;\n      margin-bottom: 0;\n      margin-top: 10px;\n      padding-left: 0;\n  }\n  .footer-menu-list li {\n      margin-top: 5px;\n  }\n  \n  .footer-call-to-action-description {\n      color: #fffff2;\n      margin-top: 10px;\n      margin-bottom: 20px;\n  }\n  .footer-call-to-action-button:hover {\n      background-color: #fffff2;\n      color: #00bef0;\n  }\n  .button:last-of-type {\n      margin-right: 0;\n  }\n  .footer-call-to-action-button {\n      background-color: #027b9a;\n      border-radius: 21px;\n      color: #fffff2;\n      display: inline-block;\n      font-size: 11px;\n      font-weight: 900;\n      letter-spacing: .1em;\n      line-height: 18px;\n      padding: 12px 30px;\n      margin: 0 10px 10px 0;\n      text-decoration: none;\n      text-transform: uppercase;\n      transition: background-color .2s;\n      cursor: pointer;\n      position: relative;\n  }\n  .footer-call-to-action {\n      margin-top: 30px;\n  }\n  .footer-call-to-action-title {\n      color: #fffff2;\n      font-size: 14px;\n      font-weight: 900;\n      letter-spacing: .1em;\n      line-height: 18px;\n      margin-bottom: 0;\n      margin-top: 0;\n      text-transform: uppercase;\n  }\n  .footer-call-to-action-link-wrapper {\n      margin-bottom: 0;\n      margin-top: 10px;\n      color: #fff;\n      text-decoration: none;\n  }\n  .footer-call-to-action-link-wrapper a {\n      color: #fff;\n      text-decoration: none;\n  }\n  \n  \n  \n  \n  \n  .footer-social-links {\n      bottom: 0;\n      height: 54px;\n      position: absolute;\n      right: 0;\n      width: 236px;\n  }\n  \n  .footer-social-amoeba-svg {\n      height: 54px;\n      left: 0;\n      display: block;\n      position: absolute;\n      top: 0;\n      width: 236px;\n  }\n  \n  .footer-social-amoeba-path {\n      fill: #027b9a;\n  }\n  \n  .footer-social-link.linkedin {\n      height: 26px;\n      left: 3px;\n      top: 11px;\n      width: 26px;\n  }\n  \n  .footer-social-link {\n      display: block;\n      padding: 10px;\n      position: absolute;\n  }\n  \n  .hidden-link-text {\n      position: absolute;\n      clip: rect(1px 1px 1px 1px);\n      clip: rect(1px,1px,1px,1px);\n      -webkit-clip-path: inset(0px 0px 99.9% 99.9%);\n      clip-path: inset(0px 0px 99.9% 99.9%);\n      overflow: hidden;\n      height: 1px;\n      width: 1px;\n      padding: 0;\n      border: 0;\n      top: 50%;\n  }\n  \n  .footer-social-icon-svg {\n      display: block;\n  }\n  \n  .footer-social-icon-path {\n      fill: #fffff2;\n      transition: fill .2s;\n  }\n  \n  .footer-social-link.twitter {\n      height: 28px;\n      left: 62px;\n      top: 3px;\n      width: 28px;\n  }\n  \n  .footer-social-link.youtube {\n      height: 24px;\n      left: 123px;\n      top: 12px;\n      width: 24px;\n  }\n  \n  .footer-social-link.github {\n      height: 34px;\n      left: 172px;\n      top: 7px;\n      width: 34px;\n  }\n  \n  .footer-copyright {\n      background-color: #027b9a;\n      color: #fff;\n      padding: 15px 30px;\n    text-align: center;\n  }\n  \n  .footer-copyright-wrapper {\n      margin-left: auto;\n      margin-right: auto;\n      max-width: 1200px;\n  }\n  \n  .footer-copyright-text {\n    color: #fff;\n      font-size: 13px;\n      font-weight: 400;\n      line-height: 18px;\n      margin-bottom: 0;\n      margin-top: 0;\n  }\n  \n  .footer-copyright-link {\n      color: #fff;\n      text-decoration: none;\n  }\n  \n  \n  \n  \n  \n  \n  \n  /* Media Query For different screens */\n  @media (min-width:320px) and (max-width:479px)  { /* smartphones, portrait iPhone, portrait 480x320 phones (Android) */\n    .footer-content {\n      margin-left: auto;\n      margin-right: auto;\n      max-width: 1230px;\n      padding: 40px 15px 450px;\n      position: relative;\n    }\n  }\n  @media (min-width:480px) and (max-width:599px)  { /* smartphones, Android phones, landscape iPhone */\n    .footer-content {\n      margin-left: auto;\n      margin-right: auto;\n      max-width: 1230px;\n      padding: 40px 15px 450px;\n      position: relative;\n    }\n  }\n  @media (min-width:600px) and (max-width: 800px)  { /* portrait tablets, portrait iPad, e-readers (Nook/Kindle), landscape 800x480 phones (Android) */\n    .footer-content {\n      margin-left: auto;\n      margin-right: auto;\n      max-width: 1230px;\n      padding: 40px 15px 450px;\n      position: relative;\n    }\n  }\n  @media (min-width:801px)  { /* tablet, landscape iPad, lo-res laptops ands desktops */\n  \n  }\n  @media (min-width:1025px) { /* big landscape tablets, laptops, and desktops */\n  \n  }\n  @media (min-width:1281px) { /* hi-res laptops and desktops */\n  \n  }\n  \n  \n  \n  \n  @media (min-width: 760px) {\n    .footer-content {\n        margin-left: auto;\n        margin-right: auto;\n        max-width: 1230px;\n        padding: 40px 15px 450px;\n        position: relative;\n    }\n  \n    .footer-wave-svg {\n        height: 50px;\n    }\n  \n    .footer-content-column {\n        width: 24.99%;\n    }\n  }\n  @media (min-width: 568px) {\n    /* .footer-content-column {\n        width: 49.99%;\n    } */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
